import React from 'react'
import { useAccess } from './AccessContext'

export default function RouteAccessGate({ anyOf, systemAdministratorOnly = false, children }) {
	const access = useAccess()
	if (access.loading) return <main role="status" className="rounded-xl border border-slate-200 bg-white p-8"><h1 className="text-xl font-semibold">Loading access…</h1><p className="mt-2 text-slate-600">Confirming your effective permissions.</p></main>
	if ((systemAdministratorOnly && !access.isSystemAdministrator) || (!systemAdministratorOnly && !access.canAny(anyOf))) return <main role="alert" className="rounded-xl border border-amber-200 bg-amber-50 p-8"><h1 className="text-xl font-semibold text-amber-950">Access Denied</h1><p className="mt-2 text-amber-900">You are signed in, but do not have permission to view this workspace.</p></main>
	return children
}
